import * as _ from 'lodash';

export default angular.module('cian.newbuild.upperFirstFilter', [])
  .filter('upperFirst', [
    () => _.upperFirst
  ])
  .name;



// WEBPACK FOOTER //
// ./src/serp/filters/upper-first.filter.js